/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SneakersInputs */

const en_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sneakers`)
};

const es_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapatillas`)
};

const fr_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baskets`)
};

const de_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sneaker`)
};

const ja_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スニーカー`)
};

const zh_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运动鞋`)
};

const ar_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحذية رياضية (سنيكرز)`)
};

const id_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sneakers`)
};

const it_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sneakers`)
};

const ru_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кроссовки`)
};

const pt_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tênis`)
};

const ko_val_sneakers = /** @type {(inputs: Val_SneakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스니커즈`)
};

/**
* | output |
* | --- |
* | "Sneakers" |
*
* @param {Val_SneakersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_sneakers = /** @type {((inputs?: Val_SneakersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SneakersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_sneakers(inputs)
	if (locale === "es") return es_val_sneakers(inputs)
	if (locale === "fr") return fr_val_sneakers(inputs)
	if (locale === "de") return de_val_sneakers(inputs)
	if (locale === "ja") return ja_val_sneakers(inputs)
	if (locale === "zh") return zh_val_sneakers(inputs)
	if (locale === "ar") return ar_val_sneakers(inputs)
	if (locale === "id") return id_val_sneakers(inputs)
	if (locale === "it") return it_val_sneakers(inputs)
	if (locale === "ru") return ru_val_sneakers(inputs)
	if (locale === "pt") return pt_val_sneakers(inputs)
	return ko_val_sneakers(inputs)
});